export const NLA_EXPORT = "NonLeasedAssets";
export const INVOICE_ASSETS_EXPORT = "InvoiceAssets";
export const LEASED_ASSET_TYPE = "leased";
export const NON_LEASED_ASSET_TYPE = "nonLeased";
export const INVOICE_ASSET_TYPE = "invoiceAsset";